export default __webpack_public_path__ + "static/media/p9801.5e9b4f33.png";